// Carousel.js
import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { css, keyframes } from "@emotion/react";

const CarouselContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;

const CarouselInner = styled.div`
  display: flex;
  transition: transform 0.5s ease;
  transform: ${(props) => `translateX(-${props.index * 100}%)`};
`;

const Slide = styled.div`
  min-width: 100%;
  box-sizing: border-box;
  padding: 5px 10px;
  // background-color: #f5f5f5;
  border-radius: 10px;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const RadioButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  padding: 10px;
`;

const scaleAnimation = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.3);
  }
`;

const RadioButton = styled.button`
  background: ${(props) => (props.active ? "#f37a5e" : "#ccc")};
  border: none;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin: 0 5px;
  cursor: pointer;
  transition: background 0.3s ease;

  ${(props) =>
    props.active &&
    css`
      animation: ${scaleAnimation} 0.3s forwards;
    `}

  &:focus {
    outline: none;
  }
`;

const SignupCarousel = ({ data, interval = 4000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === data.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(timer);
  }, [data.length, interval]);

  const handleRadioClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <CarouselContainer>
      <CarouselInner index={currentIndex}>
        {data.map((item, index) => (
          <Slide key={item.key}>{item.info}</Slide>
        ))}
      </CarouselInner>

      <RadioButtons>
        {data.map((_, index) => (
          <RadioButton
            key={index}
            active={index === currentIndex}
            onClick={() => handleRadioClick(index)}
          />
        ))}
      </RadioButtons>
    </CarouselContainer>
  );
};

export default SignupCarousel;
